import { useCallback } from 'react';

import { useShowPositionSummarySheet } from '@/hooks/use-show-position-summary-sheet';

import { totalStakeSelector } from '../utils/betslip-selectors';
import { getEstimatedPositionSummary } from '../utils/prediction-position';
import { usePredictionTakerFeeTheta } from './use-prediction-taker-fee-theta';
import { useSbkBetSlipStore } from './use-sbk-betslip-store';

// Shows the position summary sheet for the prediction currently on the entry slip
export const useShowPositionSummary = () => {
    const showPositionSummarySheet = useShowPositionSummarySheet();

    const takerFeeTheta = usePredictionTakerFeeTheta();
    const totalStake = useSbkBetSlipStore(totalStakeSelector);
    const odds = useSbkBetSlipStore(state => {
        const selectionId = state.selectionOrder[0];
        return selectionId ? state.options[selectionId]?.odds : undefined;
    });

    return useCallback(() => {
        const summary = getEstimatedPositionSummary(totalStake, odds ?? 0, takerFeeTheta);
        showPositionSummarySheet({ ...summary, odds });
    }, [showPositionSummarySheet, totalStake, odds, takerFeeTheta]);
};
